import { Icon } from "@focus/focusUI";

export const ReleaseNotesEmptyState = ({ hasData }: { hasData: boolean }) => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="rounded-lg border border-dashed bg-white p-8 text-center">
        <Icon icon="document-open" />

        <h3 className="mt-3 text-sm font-bold">
          {hasData ? "No release notes found" : "No release notes available"}
        </h3>

        <p className="mt-1 text-sm text-slate-500">
          {hasData
            ? "Try adjusting your filters."
            : "Release notes will appear here."}
        </p>
      </div>
    </div>
  );
};
